import { apiClient } from '@/api/client';
import type { AuthUser } from '@/types/auth';

export interface UpdateProfileBody { displayName?: string; firstName?: string; lastName?: string }
export interface ChangePasswordBody { currentPassword: string; newPassword: string }

/** Current-user profile + security — existing identity endpoints. */
export const profileApi = {
  get: async (): Promise<AuthUser> => (await apiClient.get<AuthUser>('/me')).data,
  update: async (body: UpdateProfileBody): Promise<AuthUser> => (await apiClient.patch<AuthUser>('/users/me', body)).data,
  changePassword: async (body: ChangePasswordBody): Promise<void> => { await apiClient.post('/me/password', body); },
};
